// BUILD-046 task 8.10 (supporting model): the origin label on every task row and card (Req 1.10, 13.19; design "Other presentation rules").
//
// Every row and card in both density views shows `Manual` or `From <module>`, matching the classification: a task is a Source_Owned_Task
// if and only if it carries a Source_Reference. A task whose restricted source the viewer cannot open is still source-owned, but the
// route withholds its Source_Reference, so the label says so without naming the module. Where the source adapter is a Simulated_Adapter
// (every adapter in the pilot) a SIMULATED marker is added.
//
// Pure module: no React, no I/O, no runtime imports. Erasable TypeScript only.

export interface OriginInput {
  sourceRef?: { module?: string | null } | null;
  sourceGoverned?: boolean;
  redacted?: boolean;
}

export type OriginKind = 'manual' | 'source' | 'restricted-source';

export interface OriginLabel {
  kind: OriginKind;
  /** `Manual`, `From Pricing`, or `From a restricted source`. Never empty. */
  text: string;
  /** True for a source-owned task whose adapter is simulated (Req 13.19). Never true for a Manual task. */
  simulated: boolean;
}

/** `pricing` becomes `Pricing`; `commission-review` becomes `Commission review`. */
export function moduleDisplayName(module: string): string {
  const words = module.trim().replace(/[-_\s]+/g, ' ');
  return words === '' ? words : `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
}

export function originLabel(item: OriginInput, options: { adapterSimulated?: boolean } = {}): OriginLabel {
  const module = typeof item.sourceRef?.module === 'string' ? item.sourceRef.module.trim() : '';
  const simulated = options.adapterSimulated === true;
  if (module !== '') return { kind: 'source', text: `From ${moduleDisplayName(module)}`, simulated };
  if (item.redacted === true || item.sourceGoverned === true) return { kind: 'restricted-source', text: 'From a restricted source', simulated };
  return { kind: 'manual', text: 'Manual', simulated: false };
}
